/**
 * `focusOptions` for a react-focus-lock `<FocusLock>` inside a popover.
 *
 * FocusLock focuses the popover's content as soon as it mounts, but zag
 * positions the popover a frame later, so that first focus can land below the
 * viewport and scroll the page — the popover then "jumps" with it. v2
 * positioned popovers before paint, so this never scrolled.
 */
export const FOCUS_WITHOUT_SCROLLING: FocusOptions = { preventScroll: true };
